import React, { useMemo, useState } from 'react';

import { buildSendInvite } from '../../../lib/services/invite.service';
import InviteForm from './invite-form.component';
import { getAgeGroups, useRoleAllowedAgeGroups } from '../../../lib/services/age-group.service';
import { ROLES } from '../../../../_configuration';
import { getCurrMember } from '../../../lib/services/member.service';

const InviteFormContainer = () => {
  const [showSaved, setShowSaved] = useState(false);
  const [submitError, setSubmitError] = useState<string | null>(null);

  const { sendInvite } = buildSendInvite();

  const { ageGroups } = getAgeGroups()
  const roleAllowedAgeGroups = useRoleAllowedAgeGroups({ageGroups, requiredRoles: [ROLES.USER_MANAGEMENT]});

  const handleSendInvite = (email: string, phone: string, memberRoles: IMemberRoles[]) => {
    return sendInvite(email.toLowerCase(), phone, memberRoles)
      .then(() => {
        setShowSaved(true);
        setTimeout(() => {
          setShowSaved(false)
        }, 3000);
      })
      .catch(err => {
        setSubmitError(err.message);
        setTimeout(() => {
          setSubmitError(null);
        }, 3000);
      });
  }

  const { member } = getCurrMember()
  const canInviteToOrganization = useMemo(() => member?.isAdmin || member?.superUserRoles?.includes(ROLES.USER_MANAGEMENT) || false, [member?.isAdmin, member?.superUserRoles])

  return <InviteForm
    ageGroups={roleAllowedAgeGroups}
    canInviteToOrganization={canInviteToOrganization}
    showSaved={showSaved}
    sendInvite={handleSendInvite}
    submitError={submitError}
  />;
};

export default InviteFormContainer;
